import React from "react";

const fileSizeCheck = (fileSize) => {
   return (fileSize > 999) ? `${(Math.round(fileSize) / 1000).toFixed(1)}GB` 
   : (fileSize > 1) ? `${(Math.round(fileSize * 10) / 10).toFixed(1)}MB` 
   : (fileSize>0.0009) ? `${(fileSize * 1000).toFixed(1)}KB` 
   : `${(fileSize * 1000000).toFixed(1)}B`
}

export default fileSizeCheck;